import React from 'react'
import { Flex } from '@npco/zeller-design-system'

import { LoaderSimple } from 'components/LoaderSimple'

export const ListLoader = () => (
  <Flex p="0.75rem" alignItems="center" justifyContent="center">
    <LoaderSimple size="36" />
  </Flex>
)
